"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module  timeline
 * @decision This module lists the latest messages and calls that a person has received
 */

module.exports = function (config, get, post) {
	return {
		history: history
	};

	/**
	 * History of incoming messages and calls
	 * @param  {Number}  page The page to load, defaults to 0
	 * @return {Promise}      Resolves to array of calls and texts
	 */
	function history(page) {
		return get("/v2/timeline/history", {
			page: page
		});
	}
};
